import { render, staticRenderFns } from "./taskScore.vue?vue&type=template&id=7b3c55c0&scoped=true&"
import script from "./taskScore.vue?vue&type=script&lang=js&"
export * from "./taskScore.vue?vue&type=script&lang=js&"
import style0 from "./taskScore.vue?vue&type=style&index=0&id=7b3c55c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c55c0",
  null
  
)

component.options.__file = "taskScore.vue"
export default component.exports